/**
 * PH-1: dev-mode mutex flag, separated to avoid circular imports.
 *
 * `_panel-mutex.ts` imports `useArtifactStore` to call `setDrawerOpen`.
 * `useArtifactStore` needs to call `assertMutexHelperContext` for the
 * dev-mode invariant. Both depend on this tiny module instead of each other.
 */

let _inMutexHelper = false;

export function enterMutexHelper(): void {
  _inMutexHelper = true;
}

export function exitMutexHelper(): void {
  _inMutexHelper = false;
}

export function assertMutexHelperContext(): void {
  if (import.meta.env?.DEV && !_inMutexHelper) {
    // eslint-disable-next-line no-console
    console.warn(
      '[PH-1 mutex] setDrawerOpen(true) called outside `openDrawer()`. ' +
        'Direct opens bypass the right-slot mutex — hub/dock state may not close. ' +
        'Use `openDrawer()` from `@/stores/_panel-mutex` instead.',
    );
  }
}
